import { Box } from '@mui/material';
const AsianImage = (props) => {
  return <Box component="img" alt="" {...props} />;
};

export default AsianImage;
